import Vue from 'vue'
import Vuex from 'vuex'
import session from './modules/session'
import sidebar from './modules/sidebar'
import page from './modules/page'
import user from './modules/user'
import configuration from './modules/configuration'
import contractor from './modules/contractor'
import status from './modules/status'

Vue.use(Vuex)

export default new Vuex.Store({
  modules: {
    session,
    sidebar,
    page,
    user,
    configuration,
    contractor,
    status
  }
})



// WEBPACK FOOTER //
// ./src/store/index.js